module.exports = ":host {\n    display:flex;\n    flex-direction:column;\n    flex-wrap:nowrap;\n    align-items:stretch;\n    height:100vh;\n    overflow:hidden;\n}\n\nheader {\n    height: 50px;\n    flex-grow:0;\n    flex-shrink:0;\n    width: 100%;\n}\n\nerror {\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n}\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/app.css
 ** module id = 811
 ** module chunks = 0
 **/